import React from 'react';
import './message.css'

function Message({ user, timestamp, message }) {
    return (
        <div className="message">
            <div className="message-inner">
                <div className="message-header">
                    <span className="extra-small text-muted">{user}</span>
                    <span className="extra-small text-muted">{timestamp}</span>
                </div>
                
                <div className="message-body">
                    <div className="message-content">
                        <div className="message-text">
                            <p>{message}</p>
                        </div>
                    </div>
                </div> 
            </div>
        </div>
    );
}

export default Message;